import { FC, PropsWithChildren } from 'react';

import { BrazeMarketingCard } from 'components/features/components/braze-marketing-card';
import { OnShowModalType } from 'components/features/components/braze-marketing-card/types';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';
import { ContentCardTypes } from 'state/braze/types';
import { ContentCard } from 'utils/braze';

import { ClassicContentCard } from './classic';
import { ImageOnlyContentCard } from './image-only';
import { ContentCardGridItem } from './styled';

type CustomContentCardProps = {
  card: ContentCard;
  index: number;
  onShowTermsModal: OnShowModalType;
  /** Whether the card is above the "You are all caught up" separator. */
  isUnread: boolean;
};

export const CustomContentCard: FC<PropsWithChildren<CustomContentCardProps>> = ({
  card,
  index,
  onShowTermsModal,
  isUnread,
}) => {
  const isMobile = useIsMobileBreakpoint();

  const gridItemProps = {
    flexBasis: isMobile ? '100%' : '49%',
    flexGrow: 0,
    flexShrink: 1,
  } as const;

  // Control Cards are blank and never displayed. Their impression still has to be logged so the
  // control arm of the A/B test stays comparable, and NotificationInbox does it: a card that
  // renders nothing cannot log its own the way BrazeMarketingCard does on image load.
  if (card.isControl) {
    return null;
  }

  switch (card.type) {
    case ContentCardTypes.CLASSIC:
      return (
        <ContentCardGridItem {...gridItemProps}>
          <ClassicContentCard card={card} isUnread={isUnread} />
        </ContentCardGridItem>
      );
    case ContentCardTypes.CAPTIONED:
      return (
        <BrazeMarketingCard
          card={card}
          index={index}
          dismissInboxBeforeNavigation
          onShowTermsModal={onShowTermsModal}
          isUnread={isUnread}
        />
      );
    case ContentCardTypes.IMAGE_ONLY:
      return (
        <ContentCardGridItem {...gridItemProps}>
          <ImageOnlyContentCard card={card} isUnread={isUnread} />
        </ContentCardGridItem>
      );
    default:
      return null;
  }
};
